import { Alert, Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import L from 'leaflet';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import StatusBarMenu from 'components/StatusBarMenu';
import { useHistory } from 'react-router-dom';
import useStatusBarStyles from './styles';
import { StatusBarProps, StatusItem } from './types';

const StatusBar: React.FunctionComponent<StatusBarProps> = ({
  errorFallback,
  statusItems = [],
}) => {
  const { t } = useTranslation('common');
  const classes = useStatusBarStyles();
  const history = useHistory();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef?.current) {
      L.DomEvent.disableClickPropagation(wrapperRef.current);
      L.DomEvent.disableScrollPropagation(wrapperRef.current);
    }
  });

  const onClick = (to?: string) => {
    if (!to) {
      return;
    }
    history.push(to);
  };

  const renderStatus = ({ color, count, label, to }: StatusItem) => {
    return (
      <Grid
        onClick={() => onClick(to)}
        item
        key={`status-bar-item-${label}`}
        xs={1}
        className={classes.section}
      >
        <div className={classes.fullSize}>
          <Typography variant='h4'>{count || 0}</Typography>
          <div className={classes.colorBar} style={{ backgroundColor: color }} />
          <Typography className={classes.name}>{label}</Typography>
        </div>
      </Grid>
    );
  };

  return (
    <Grid container className={classes.wrapper} justifyItems='center'>
      <Grid
        item
        columns={errorFallback ? 2 : statusItems.length + 1}
        className={classes.statusBar}
        ref={wrapperRef}
      >
        <Grid item className={clsx(classes.statusBarMenu, classes.menuSection)}>
          <StatusBarMenu />
        </Grid>
        {errorFallback ? (
          <Grid item xs={true} className={classes.errorDiv}>
            <Alert id='status-items-error' severity='error'>
              {t('common:failedToLoadStatusItems')}
            </Alert>
          </Grid>
        ) : (
          statusItems.map(renderStatus)
        )}
      </Grid>
    </Grid>
  );
};

export default StatusBar;
